<template>
  <BContainer class="mt-3 mb-3 container-pages price-section">
    <BRow>
      <BCol>
        <div v-if="advertisement" class="price-card">
          <div
            v-if="advertisement?.trade_type == 'buy'"
            class="trade-badge"
          >
            KUPUJEM
          </div>

          <div class="price-display-view">
            <div class="price-label">Cena</div>

            <h3 class="price-value mb-0">
              {{ displayPrice(advertisement?.price_type, advertisement?.price) }}
              <span
                class="currency-symbol"
                v-html="currencySymbol(advertisement.price_type, advertisement.currency_code)"
              ></span>
            </h3>
          </div>
        </div>
      </BCol>
    </BRow>
  </BContainer>
</template>

<script setup>
import { BContainer, BRow, BCol } from 'bootstrap-vue-next'

const props = defineProps({
  advertisement: {
    required: true,
    type: Object
  }
})

const { displayPrice, currencySymbol } = usePriceFormat()
</script>

 